import { render, staticRenderFns } from "./pledge.vue?vue&type=template&id=7afbb79a"
import script from "./pledge.vue?vue&type=script&lang=ts"
export * from "./pledge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports